/* Bloomable: delivery tag pills on product cards.
   Shows the pre-cutoff tag before the theme's same-day cutoff hour (SAST),
   the post-cutoff tag after it, and the Sunday tag on Sundays when set.
   Tag texts come from the product's delivery_tag metafields, rendered as
   data attributes by snippets/product-card.liquid. */
(function () {
  function updateTags() {
    var tags = document.querySelectorAll('.js-delivery-tag');
    if (!tags.length) return;

    var now = new Date();
    var hour = parseInt(now.toLocaleString('en-US', { timeZone: 'Africa/Johannesburg', hour: 'numeric', hour12: false }), 10);
    var day = now.toLocaleString('en-US', { timeZone: 'Africa/Johannesburg', weekday: 'long' });

    tags.forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var text = '';
      // The Sunday tag only applies when we don't deliver on Sundays
      var sundayClosed = !(window.blmDeliveryRules && window.blmDeliveryRules.includeSundays);
      if (day === 'Sunday' && sundayClosed && el.getAttribute('data-sunday')) {
        text = el.getAttribute('data-sunday');
      } else if (hour < cutoff) {
        text = el.getAttribute('data-before') || '';
      } else {
        text = el.getAttribute('data-after') || '';
      }
      if (text) {
        el.textContent = text;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  var scheduled = null;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = setTimeout(function () {
      scheduled = null;
      updateTags();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTags);
  } else {
    updateTags();
  }

  // Product grids re-render via AJAX (filtering, pagination, carousels) —
  // catch newly inserted cards. Element-node guard prevents reacting to our
  // own text updates.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('.js-delivery-tag')) ||
            (node.querySelector && node.querySelector('.js-delivery-tag'))) {
          scheduleUpdate();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Flip the tags live when the clock crosses the cutoff
  setInterval(updateTags, 60000);
})();
